import React from "react";
import { Alert } from "@vkontakte/vkui";
import { connect } from "react-redux";
import styles from "./ConfirmLogoutAlert.style";
import { setActiveAlert } from "../../redux/actions/alertsActions";
import { logout } from "../../redux/actions/userActions";

const ConfirmLogoutAlert = ({ hideConfirmLogoutAlert, logout }) => {
  return (
    <Alert
      actions={[
        {
          title: "Отмена",
          autoclose: true,
        },
        {
          title: "Да",
          autoclose: true,
          action: () => logout(),
        },
      ]}
      onClose={() => {
        hideConfirmLogoutAlert();
      }}
    >
      <h2 style={styles.black}>Выход из учётной записи</h2>
      <p style={styles.gray}>Уверены, что хотите выйти?</p>
    </Alert>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(logout()),
    hideConfirmLogoutAlert: () => dispatch(setActiveAlert(null)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmLogoutAlert);
